import * as React from 'react';
import * as d3 from 'd3';
import './customRadialChart.css';
import CustomRadialChart from './customRadialChart.Component'
const determineFill = (alertLevel) => {
        if(alertLevel === 1) {
            return "#18ee97";
        }
        else if(alertLevel ===  2) {
            return "#feb743";
        }
        else if(alertLevel === 3){
            return "#f56f3f";
        }
        else if(alertLevel === 4){
          return "#8e0666";
        }
        else if(alertLevel === 5){
            return "#e7233d";
        }
        else {
            return "#fff";
        }
    }
const SingleResponseChart = props => {
     
        return(
            <div className="custom-radial-cont">
                <div className="response-cont">
                    <p className="response-q">{props.question}</p>
                    <p className = "response-a" style={{borderColor: determineFill(props.alertLevel)}}>{props.answer}</p>
                </div>
                
                <CustomRadialChart 
                    alertLevel= {props.alertLevel}/>
                <p className="alert-level" style={{color: determineFill(props.alertLevel)}}>Alert Level {props.alertLevel}</p>
            </div>
        );
}
export default SingleResponseChart;




// WEBPACK FOOTER //
// ./src/common/singleResponseChart.Component.js